import { useEffect } from 'react';
import { saveUTMParameters } from '../lib/analytics';

/**
 * Hook to save UTM parameters on component mount
 * Should be used in App.js or main component
 */
export const useUTM = () => {
	useEffect(() => {
		// Save UTM parameters if present in URL
		saveUTMParameters();
	}, []);
};

